import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";

export interface SelectProps {
    field?: any;
    form?: any;
    items?: { label: any; value: any }[];
    givenid?: string;
    noValueLabel?: string;
    multipleSelection?: boolean;
    sourceChanges?: boolean;
    disabled?: boolean;
    headerContainer?: any;
    isConfig?: boolean;
}

export default class BaseSelect extends Component<SelectProps, {}> {
    selectBox: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);

        this.selectBox = React.createRef();
    }

    onChangeHandler = e => {
        let { touched } = this.props.form;
        touched[this.props.field.name] = true;
        this.props.form.setTouched(touched);
        this.props.form.setFieldValue(this.props.field.name, e);
    };

    componentDidUpdate(prevProps) {
        if (this.props.field.name == "proportion_type") {
            if (
                this.props.field.value != undefined &&
                this.props.field.value != ""
            ) {
                this.selectBox.current.setDisplayString(
                    this.props.field.value === 'proportional'
                        ? 'Proportional'
                        : this.props.field.value === 'fractionated'
                            ? 'Fractionated' : 'Normal'
                );
            }
        }

        if (this.props.disabled &&
            (this.props.givenid == "type_preset" ||
                this.props.givenid == "subsidiary_preset" ||
                this.props.givenid == "stype_preset" ||
                this.props.givenid == "proportional_preset")) {
            const value = this.props.items.find(item => item.value === this.props.field.value)
            if (value) this.selectBox.current.setDisplayString(value.label);
        }

        if (
            (this.props.field.name == "game_ramp_type" ||
                this.props.field.name == "game_duration_type") &&
            this.props.field.value != undefined &&
            this.props.field.value != ""
        ) {
            this.selectBox.current.selectItem(this.props.field.value);
            const item = this.props.items.find(
                item => item.value == this.props.field.value
            );
            this.selectBox.current.setDisplayString(item.label);
        }
    }

    render() {
        const fieldName = this.props.field.name;
        const errors =
            this.props.form.errors[fieldName] != "Field is required."
            || (this.props.isConfig && !this.props.disabled)
                ? this.props.form.errors[fieldName]
                : this.props.form.touched[fieldName] &&
                  this.props.form.errors[fieldName];

        const errorMessageEl = errors && (
            <div className="input-error">
                <span className="input-error-message">{errors}</span>
            </div>
        );

        return (
            <div id={this.props.givenid + "Select"}>
                <div className="input-group">
                    <Components.SelectMenu
                        ref={this.selectBox}
                        value={this.props.field.value}
                        noValueLabel={this.props.noValueLabel}
                        onChange={this.onChangeHandler}
                        items={this.props.items}
                        multipleSelection={this.props.multipleSelection}
                        headerContainer={this.props.headerContainer}
                        disabled={this.props.disabled}
                    />
                </div>
                {errorMessageEl}
            </div>
        );
    }
}
